import {ITEM_TYPE} from 'am-constants';

function checkIfItemIsFolder (item) {
  return item.itemTypeId === ITEM_TYPE.FOLDER;
}

export default checkIfItemIsFolder;
